import { useState, useEffect } from "react";
import axios from "axios";
import Scout from "../../pages/Scout/Scout";

const contemPonto = (arr) => arr.some((item) => String(item).includes("#"));
const GravarBlocos = async (
  codAtual,
  lastScout,
  idPartida,
  newSetNum,
  firstScout,
  parametros,
  homeLeft
) => {
  const {
    Rotation: { home, away },
    setNum: num,
    setters: sett,
    serving: serv,
    score,
  } = lastScout;

  const newScout = {
    "*": home,
    a: away,
    setNum: parseInt(newSetNum),
    sett,
    score,
    serv,
  };

  let novoPlacar;

  ///marcar ponto
  // rotacao
  // substituicao
  // troca de libero
  // novo campo de libero
  // cor de libero e levantador
  // placar final = troca de set
  //? tempo

  try {
    // Processa cada item em sequência
    for (const [index, cod] of codAtual.entries()) {
      const codCurto = cod.slice(0, 6); /// SÓ GRAVA AS 5 PRIMEIRAS POSIÇÕES
      const finalCod = codCurto.charAt(codCurto.length - 1);
      const recepcao = codCurto.charAt(3).toUpperCase() === "R" ? true : false;

      if (
        // ainda nao identificou ponto, o código não é recepção
        !novoPlacar &&
        ((finalCod === "#" && !recepcao) || finalCod === "=")
      ) {
        novoPlacar = tratarPonto(serv, codCurto, score, home, away, sett);
      }
      try {
        await fetchBlocks(codCurto, newScout, idPartida);

        if (index === codAtual.length - 1) {
          // último bloco
          const newPlacar = tratarPonto(
            serv,
            codCurto,
            score,
            home,
            away,
            sett
          );
          if (newPlacar) {
            await fimDeRally(
              newPlacar,
              newScout,
              idPartida,
              parametros,
              firstScout
            );
          }

          // fimPartida(novoPlacar, newScout, idPartida, parametros);
          novoPlacar = "";
        }
      } catch (error) {
        console.error(`Erro no bloco ${index}:`, error);
        throw error;
      }
    }
  } catch (error) {
    console.error("Erro geral:", error);
    throw error;
  }
};

const fetchBlocks = async (cod, newScout, idPartida) => {
  const { "*": home, a: away, sett, score, setNum, serv, left } = newScout;
  const reduzInicial = cod.charAt(0).toLowerCase() + cod.slice(1);

  const payload = {
    partida: idPartida,
    home,
    away,
    serv,
    sett,
    score,
    cod: reduzInicial,
    num: setNum,
    ...(typeof left === "boolean" && { left }), // Só adiciona se for true ou false
  };

  try {
    const response = await axios.post(
      `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/matches/scout`,
      payload
    );

    return response?.data[0] || null;
  } catch (error) {
    console.error("Erro ao buscar dados do bloco:", error);
    throw error;
  }
};

const tratarPonto = (quemSacou, codigo, placarAtual, home, away, sett) => {
  const tipoAcao = codigo.charAt(codigo.length - 1);
  let quemPontuou;

  if (tipoAcao === "#") {
    quemPontuou = codigo.slice(0, 1);
  } else {
    quemPontuou = codigo.slice(0, 1) === "*" ? "a" : "*";
  }

  let novoPlacar = [0, 0];
  let novoHome = [...home];
  let novoAway = [...away];
  let novoSett = [...sett];

  if (quemSacou !== quemPontuou) {
    if (quemPontuou === "*") {
      novoPlacar = [placarAtual[0] + 1, placarAtual[1]];

      // Rotação: apenas posições 0-5
      const rotating = novoHome.slice(0, 6);
      const fixed = novoHome[6]; // posição 7, fixa
      const [first, ...rest] = rotating;
      novoHome = [...rest, first, fixed];

      novoSett = [sett[0] === 1 ? 6 : sett[0] - 1, sett[1]];
    } else {
      novoPlacar = [placarAtual[0], placarAtual[1] + 1];

      const rotating = novoAway.slice(0, 6);
      const fixed = novoAway[6]; // posição 7, fixa
      const [first, ...rest] = rotating;
      novoAway = [...rest, first, fixed];

      novoSett = [sett[0], sett[1] === 1 ? 6 : sett[1] - 1];
    }
  } else {
    novoPlacar =
      quemPontuou === "*"
        ? [placarAtual[0] + 1, placarAtual[1]]
        : [placarAtual[0], placarAtual[1] + 1];
    // sem rotação se quem sacou pontuou
  }

  return {
    newHome: novoHome,
    newAway: novoAway,
    newScore: novoPlacar,
    newSett: novoSett,
    pontoDe: quemPontuou.toLowerCase(),
  };
};

const fimDeRally = async (
  novoPlacar,
  ultimosDados,
  idPartida,
  parametros,
  firstScout
) => {
  const { newHome, newAway, newScore, newSett, pontoDe } = novoPlacar;
  const { "*": home, a: away, setNum, sett, score, serv } = ultimosDados;
  let bodies;
  let sets;
  //grava o ponto
  try {
    const codePonto = pontoDe + "p" + newScore[0] + ":" + newScore[1];

    const novoPonto = {
      "*": home,
      a: away,
      sett,
      score: newScore,
      setNum: parseInt(setNum),
      serv: pontoDe,
    };

    try {
      // grava resultado do rally
      const Scout = await fetchBlocks(codePonto, novoPonto, idPartida);
    } catch (error) {
      console.error("Erro ao gravar 181", error);
      throw error;
    }

    //verifica fim do set
    const placar = novoPlacar.newScore;
    const melhorDe = parametros.melhorde;
    const LimitePontosSet = parametros.pontosset; //0-set regular 1-tie-break
    const pontosPorSet = parametros.sets;

    const tieBreak = melhorDe === ultimosDados.setNum ? true : false;

    const vencedorSet = verificarFimDoSet(
      placar[0],
      placar[1],
      LimitePontosSet,
      tieBreak
    );

    try {
      const response = await axios.post(
        `${
          import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
        }/reports/placar-geral`,
        { partida: idPartida }
      );
      sets = response.data;
    } catch (error) {
      console.error("Erro ao gravar o placar", error);
      throw error;
    }

    if (vencedorSet.setFinalizado) {
      //verifica se algum dos sets chegou ao valor do melhor de
      const setsHome = sets.home;
      const setsAway = sets.away;
      const maximo = Math.max(setsHome, setsAway);

      if (maximo === melhorDe) {
        // fim da partida
        // await fimPartida(novoPlacar, ultimosDados, idPartida, parametros); // nao precisa mais gravar fim do jogo
        alert("Fim de jogo");
      } else {
        //grava fim do set
        await fetchBlocks(vencedorSet.vencedor + "*1Set", novoPonto, idPartida);

        // novo set
        const proximoSet = montaProximoSet(ultimosDados.setNum, firstScout);
        await fetchBlocks(proximoSet.codigo, proximoSet.newScout, idPartida);
        alert("Fim de set");
        window.location.reload();
      }
    } else {
      //faz a rotação
      if (serv != pontoDe) {
        try {
          const codeRotacao =
            pontoDe === "*"
              ? pontoDe + "z" + newSett[0]
              : pontoDe + "z" + newSett[1];
          const novosDados = {
            "*": newHome,
            a: newAway,
            sett: newSett,
            score: newScore,
            setNum,
            serv: pontoDe,
          };
          const Scout = await fetchBlocks(codeRotacao, novosDados, idPartida);
        } catch (error) {
          console.error(`Erro no bloco de rotacao`, error);
        }
      }
    }
  } catch (error) {
    console.error("Erro ao finalizar rally:", error);
    throw error;
  }
};

const fimPartida = async (novoPlacar, ultimosDados, idPartida, parametros) => {
  const { newScore } = novoPlacar;
  const { setNum } = ultimosDados;

  try {
    const response = await axios.put(
      `${
        import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
      }/matches/partida/${idPartida}`,
      {
        setsUpdate: { [setNum]: newScore },
        concluido: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao finalizar partida:", error);
    throw error;
  }
};

const verificarFimDoSet = (pontosA, pontosB, pontuacao, isTieBreak = false) => {
  const limite = isTieBreak ? pontuacao[1] : pontuacao[0];

  const diferenca = Math.abs(pontosA - pontosB);

  // Verifica se algum time atingiu ou passou o limite E tem 2 pontos de diferença
  if ((pontosA >= limite || pontosB >= limite) && diferenca >= 2) {
    const vencedor = pontosA > pontosB ? "*" : "a";
    return {
      setFinalizado: true,
      vencedor: vencedor,
      placar: `${pontosA} x ${pontosB}`,
    };
  }

  return {
    setFinalizado: false,
    vencedor: null,
    placar: `${pontosA} x ${pontosB}`,
  };
};

const montaProximoSet = (set, firstScout) => {
  let novoHome = [];
  let novoAway = [];
  const num = parseInt(set) + 1;
  const serv = firstScout.serving === "*" ? "a" : "*";
  let sett = [];
  if (serv === "a") {
    sett = [
      firstScout.setters[0] === 6 ? 1 : firstScout.setters[0] + 1, //volta uma rotação (6 vira 1 e 1 vira 2)
      firstScout.setters[1] === 1 ? 6 : firstScout.setters[1] - 1, //aumenta gira 1x (2, vira 1, era 1, vira 1)
    ];
    // Rotação: apenas posições 0-5

    const { home, away } = firstScout.Rotation;
    novoHome = [...home];
    novoAway = [...away];

    const rotating = novoHome.slice(0, 6);
    const fixed = novoHome[6]; // posição 7, fixa
    const [um, dois, tres, quatro, cinco, seis] = rotating;
    novoHome = [seis, um, dois, tres, quatro, cinco, fixed];

    const rotatingA = novoAway.slice(0, 6);
    const fixeda = novoAway[6]; // posição 7, fixa
    const [umA, doisA, tresA, quatroA, cincoA, seisA] = rotatingA;
    novoAway = [doisA, tresA, quatroA, cincoA, seisA, umA, fixeda];
  } else {
    sett = [
      firstScout.setters[0] === 1 ? 6 : firstScout.setters[0] - 1, //aumenta gira 1x (2, vira 1, era 1, vira 1)
      firstScout.setters[1] === 6 ? 1 : firstScout.setters[1] + 1, //volta uma rotação (6 vira 1 e 1 vira 2)
    ];
    // Rotação: apenas posições 0-5

    const { home, away } = firstScout.Rotation;
    novoHome = [...home];
    novoAway = [...away];
    const rotating = novoHome.slice(0, 6);
    const fixed = novoHome[6]; // posição 7, fixa
    const [um, dois, tres, quatro, cinco, seis] = rotating;
    novoHome = [dois, tres, quatro, cinco, seis, um, fixed];

    const rotatingA = novoAway.slice(0, 6);
    const fixeda = novoAway[6]; // posição 7, fixa
    const [umA, doisA, tresA, quatroA, cincoA, seisA] = rotatingA;
    novoAway = [seisA, umA, doisA, tresA, quatroA, cincoA, fixeda];
  }

  const codigo = "**nSet";
  const response = {
    codigo,
    newScout: {
      "*": novoHome,
      a: novoAway,
      sett,
      score: [0, 0],
      setNum: num,
      serv,
      left: !firstScout.left,
    },
  };
  return response;
  // const posicaoHome = firstScout.sett[0] < 6 ? firstScout[0]
  // const sett = []
  //
};
export default GravarBlocos;
